import { useCallback, useEffect, useState } from "react";
import { Flex, Modal, Table, TablePaginationConfig } from "antd";
import styled from "styled-components";
import { TParamsUser } from "services/UserManagement";
import { User } from "services/auth";
import { SorterResult } from "antd/es/table/interface";
import { getContactsApi } from "services/contact";

export const parseMentions = (input: string) => {
  const mentionRegex = /\{@\}\[(.+?)\]\((\d+)\)/g;
  let text = "";
  const mentions: {
    userId: number;
    name: string;
    start: number;
    end: number;
  }[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = mentionRegex.exec(input))) {
    const [full, name, userId] = match;
    const start = match.index;
    text += input.substring(lastIndex, start);
    const mentionStart = text.length;
    text += name;
    mentions.push({
      userId: Number(userId),
      name,
      start: mentionStart,
      end: mentionStart + name.length,
    });

    lastIndex = start + full.length;
  }
  text += input.substring(lastIndex);

  return { text, mentions };
};

const initFilter = {
  page: 1,
  limit: 10,
  total: 0,
};

type Report = {
  createdAt: string;
  description: string;
  id: number;
  reason: string;
  user: User;
};

export enum TContactReason {
  BUG = "Report a bug",
  FEATURE = "Suggest a feature",
  ACCOUNT = "Account issue",
  CONTENT = "Content issue",
  PAYMENT = "Payment issue",
  TECHNICAL = "Technical support",
  PRIVACY = "Privacy question",
  DELETE_ACCOUNT = "Request account deletion",
  OTHER = "Other",
}

const ContactUs = () => {
  const [data, setData] = useState<Report[]>([]);
  const [params, setParams] = useState<TParamsUser>(initFilter);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = useCallback(async (params?: TParamsUser) => {
    setIsLoading(true);
    try {
      const { data } = await getContactsApi(params);
      setData(data.data);
      setParams((pre) => ({
        ...pre,
        total: data.total,
        page: params?.page ?? pre.page,
      }));
    } catch (error: any) {
      Modal.error({
        content: error.response?.data.message || "Fetch data failed",
      });
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleChangeTable = useCallback(
    (
      { current, pageSize }: TablePaginationConfig,
      _: any,
      { order, field }: SorterResult
    ) => {
      if (!current || !pageSize) return;
      fetchData({
        ...params,
        page: current!,
        limit: pageSize!,
        order: order ? (order === "ascend" ? "asc" : "desc") : "",
        sortBy: (field as string) || "",
      });
    },
    [fetchData, params]
  );

  const columns = [
    {
      title: "User",
      dataIndex: "user",
      key: "user",
      render: ({ firstName, lastName, email, phone }: User) => (
        <p>{`${firstName || ""} ${lastName || ""} (${email ?? phone})`}</p>
      ),
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      render: (v: keyof typeof TContactReason) => TContactReason[v],
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
  ];

  console.log("data", data);

  return (
    <WrapperUserManagement>
      <h1>Contact Us</h1>
      <Table<Report>
        loading={isLoading}
        dataSource={data}
        onChange={handleChangeTable as any}
        pagination={{
          current: params.page,
          pageSize: params.limit,
          total: params.total,
          showSizeChanger: false,
        }}
        columns={columns}
      />
    </WrapperUserManagement>
  );
};

export default ContactUs;

const WrapperUserManagement = styled(Flex)`
  width: 100%;
  flex-direction: column;
  gap: 20px;
  &.ant-pagination {
    margin: 8px 0px !important;
  }
  > h1 {
    margin: 0;
  }
`;
